import React from 'react';
import socketIOClient from 'socket.io-client';
import { debugLog } from '../common/debugUtilities';
const SocketIOContext = React.createContext(null);

export const withSocketIO = Component => props => (
  <SocketIOContext.Consumer>
    {socketio => 
      <Component 
        {...props}
        socketio={socketio}
      />
    }
  </SocketIOContext.Consumer>
);

let servicesSocketInitiated = false;
let socket = null;
let socketEndpoint = process.env.REACT_APP_CPAP_API;

if (!socketEndpoint) {
  debugLog('Getting local socket endpoint');
  socketEndpoint = 'http://127.0.0.1:4001';
}
export function initializeSocket() {
  if (!servicesSocketInitiated){
    socket = socketIOClient(socketEndpoint, {
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000,
      transports: ['polling', 'websocket']
    });

    socket.on('connect', () => {
      debugLog('Socket.IO connected');
    });

    socket.on('disconnect', (reason) => {
      debugLog('Socket.IO disconnected:', reason);
    });

    socket.on('reconnect', (attemptNumber) => {
      debugLog('Socket.IO reconnected after', attemptNumber, 'attempts');
    });

    socket.on('reconnect_attempt', (attemptNumber) => {
      debugLog('Socket.IO reconnection attempt:', attemptNumber);
    });

    socket.on('reconnect_error', (error) => {
      debugLog('Socket.IO reconnection error:', error.message);
    });

    socket.on('connect_error', (error) => {
      debugLog('Socket.IO connection error:', error.message);
    });

    servicesSocketInitiated = true;
    return socket;
  }
  else{
    return socket;
  }
}
export default SocketIOContext;